var bybSet = [];
var bybTiers = [];
var bybDrag = null;
var bybSoldOutImg =
  "https://cdn.shopify.com/s/files/1/0847/4663/3558/files/Vector_6_56ab3e79-0538-44df-87fb-64725bb964ef.png?v=1758652937";

function bybMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

function bybTier(count) {
  var active = null;
  for (var i = 0; i < bybTiers.length; i++) {
    if (count >= bybTiers[i].min) active = bybTiers[i];
  }
  return active;
}

function bybNextTier(count) {
  for (var i = 0; i < bybTiers.length; i++) {
    if (count < bybTiers[i].min) return bybTiers[i];
  }
  return null;
}

function bybVariant(item) {
  for (var i = 0; i < item.variants.length; i++) {
    if (item.variants[i].id === item.id) return item.variants[i];
  }
  return null;
}

function bybSwatchHtml(v) {
  return (
    '<span class="byb-item__swatch">' +
    (v.swatch ? '<img src="' + v.swatch + '" alt="">' : "") +
    (v.available === false
      ? '<img class="byb-item__soldout" src="' + bybSoldOutImg + '" alt="">'
      : "") +
    "</span>"
  );
}

function bybItemHtml(item, i) {
  var html =
    '<div class="byb-item">' +
    '<span class="byb-item__thumb"><img src="' +
    item.img +
    '" alt=""></span>' +
    '<span class="byb-item__info"><span class="byb-item__title">' +
    item.title +
    "</span>";

  if (item.variants.length) {
    var current = bybVariant(item) || item.variants[0];
    html +=
      '<div class="byb-dd"><button type="button" class="byb-dd__btn">' +
      bybSwatchHtml(current) +
      '<span class="byb-dd__label">' +
      current.shade +
      '</span><span class="byb-chev"></span></button><div class="byb-dd__menu">';
    $.each(item.variants, function (j, v) {
      html +=
        '<button type="button" class="byb-dd__opt' +
        (v.id === item.id ? " is-active" : "") +
        (v.available === false ? ' is-oos" disabled' : '"') +
        ' data-index="' +
        i +
        '" data-id="' +
        v.id +
        '">' +
        bybSwatchHtml(v) +
        '<span class="byb-dd__label">' +
        v.shade +
        "</span></button>";
    });
    html += "</div></div>";
  } else {
    html += '<span class="byb-item__one">One size</span>';
  }

  return (
    html +
    '</span><span class="byb-item__price">' +
    bybMoney(item.price).replace(".00", "") +
    "</span>" +
    '<button type="button" class="byb-item__remove" data-index="' +
    i +
    '" aria-label="Remove">&times;</button></div>'
  );
}

function bybRender() {
  var $side = $(".byb-side, .byb-bar");
  if (!$side.length) return;

  var count = bybSet.length;
  var tier = bybTier(count);
  var next = bybNextTier(count);
  var pct = tier ? tier.pct : 0;
  var subtotal = 0;
  var html = "";

  $.each(bybSet, function (i, item) {
    subtotal += item.price;
    html += bybItemHtml(item, i);
  });

  var discount = Math.round((subtotal * pct) / 100);
  var total = subtotal - discount;

  $side.toggleClass("is-empty", count === 0);
  if (count === 0) bybSheet(false);
  $side.find(".byb-side__list").html(html);
  $side.find(".byb-side__count-num").text(count);
  $side.find(".byb-side__count-word").text(count === 1 ? "item" : "items");
  $(".byb-builder__count-num").text(count);
  $(".byb-builder__count-word").text(count === 1 ? "ITEM" : "ITEMS");
  $side.find(".byb-side__subtotal").text(bybMoney(subtotal));
  $side.find(".byb-side__bar-price s").toggle(discount > 0);
  $side.find(".byb-side__pct").text(pct);
  $side.find(".byb-side__discount").text("−" + bybMoney(discount));
  $side.find(".byb-side__total").text(bybMoney(total));

  $side.find(".byb-step").each(function () {
    var min = Number($(this).data("min"));
    $(this)
      .toggleClass("is-done", count >= min)
      .toggleClass("is-next", !!next && next.min === min);
  });

  $side
    .find(".byb-side__hint")
    .text(
      next
        ? "Add " +
            (next.min - count) +
            " more item" +
            (next.min - count > 1 ? "s" : "") +
            " to unlock " +
            next.pct +
            "% off"
        : "You've unlocked " + pct + "% off",
    );
  $side
    .find(".byb-side__more")
    .toggle(count > 0 && !!next)
    .text(
      next
        ? "+ ADD " + (next.min - count) + " MORE TO REACH " + next.pct + "% OFF"
        : "",
    );

  var label = $(".byb-builder").data("checkout-label");
  $side
    .find(".byb-checkout")
    .prop("disabled", count === 0)
    .text(count ? label + " · " + bybMoney(total) : label);
  bybCardStates();
  bybBarSpace();
}

function bybBarSpace() {
  var $bar = $(".byb-bar");
  $("body").css(
    "padding-bottom",
    $bar.is(":visible") ? $bar.outerHeight() : "",
  );
}

function bybCountOf(id) {
  return $.grep(bybSet, function (item) {
    return item.id === id;
  }).length;
}

function bybCardStates() {
  $(".byb-card").each(function () {
    var qty = bybCountOf(
      Number($(this).find(".byb-card__swatch.is-active").data("id")),
    );
    $(this)
      .find(".byb-card__added")
      .toggleClass("is-visible", qty > 0)
      .text("Already in your set" + (qty > 1 ? " · " + qty + "×" : ""));
    $(this)
      .find(".byb-card__swatch")
      .each(function () {
        var count = bybCountOf(Number($(this).data("id")));
        $(this)
          .toggleClass("is-in-set", count > 0)
          .attr("data-count", count || null);
      });
  });
}

function bybCloseMenus() {
  $(".byb-dd").removeClass("is-open");
  $(".byb-dd-float").hide();
}

function bybPlaceMenu($dd) {
  if (window.innerWidth > 767) return;

  var $side = $(".byb-side");
  var $float = $(".byb-dd-float");
  if (!$float.length)
    $float = $('<div class="byb-dd__menu byb-dd-float"></div>').appendTo($side);

  var s = $side[0].getBoundingClientRect();
  var r = $dd.find(".byb-dd__btn")[0].getBoundingClientRect();
  var below = s.bottom - r.bottom - 12;
  var above = r.top - s.top - 12;
  var up = below < 220 && above > below;

  $float
    .html($dd.find(".byb-dd__menu").html())
    .show()
    .css({
      top: up ? "auto" : r.bottom - s.top + 4,
      bottom: up ? s.bottom - r.top + 4 : "auto",
      minWidth: Math.max(r.width, 200),
      maxWidth: s.width - 16,
      maxHeight: Math.min(240, up ? above : below),
    });
  $float.css(
    "left",
    Math.max(8, Math.min(r.left - s.left, s.width - $float.outerWidth() - 8)),
  );
}

function bybSheet(open) {
  bybCloseMenus();
  $(".byb-side").toggleClass("is-open", open);
  $(".byb-side-overlay").toggleClass("is-open", open);
  $("body").toggleClass("byb-lock", open);
}

function bybDragStart(e) {
  if ($(e.target).closest(".byb-checkout, .byb-side__hide").length) return;
  bybCloseMenus();
  var $sheet = $(".byb-side");
  var h = $sheet.outerHeight();
  var base = $sheet.hasClass("is-open") ? 0 : h;
  var y = e.originalEvent.touches[0].clientY;

  bybDrag = {
    h: h,
    base: base,
    offset: base,
    startY: y,
    lastY: y,
    lastT: Date.now(),
    vy: 0,
    moved: false,
  };
  $(".byb-side, .byb-side-overlay").css("transition", "none");
}

function bybDragMove(e) {
  if (!bybDrag) return;
  var y = e.originalEvent.touches[0].clientY;
  var now = Date.now();

  if (Math.abs(y - bybDrag.startY) > 6) bybDrag.moved = true;
  if (!bybDrag.moved) return;
  bybDrag.vy = (y - bybDrag.lastY) / Math.max(1, now - bybDrag.lastT);
  bybDrag.lastY = y;
  bybDrag.lastT = now;
  bybDrag.offset = Math.min(
    bybDrag.h,
    Math.max(0, bybDrag.base + y - bybDrag.startY),
  );
  $(".byb-side").css("transform", "translateY(" + bybDrag.offset + "px)");
  $(".byb-side-overlay").css("opacity", 1 - bybDrag.offset / bybDrag.h);
}

function bybDragEnd(e) {
  if (!bybDrag) return;
  var d = bybDrag;
  var open = true;
  bybDrag = null;
  if (e.cancelable) e.preventDefault();

  if (d.moved) {
    if (d.vy < -0.5) open = true;
    else if (d.vy > 0.5) open = false;
    else open = d.offset < d.h / 2;
  }
  $(".byb-side, .byb-side-overlay").css({
    transition: "",
    transform: "",
    opacity: "",
  });
  bybSheet(open);
}

function bybShowCards(key, ids) {
  var $grid = $(".byb-grid");
  var limit = ids ? 0 : Number($grid.data("limit")) || 0;

  $(".byb-card").each(function () {
    var pos = ids
      ? $.inArray(Number($(this).data("product")), ids) + 1
      : Number($(this).data(key)) || 0;
    $(this)
      .css("order", pos)
      .toggleClass("byb-hidden", !pos)
      .toggleClass("byb-more", !!limit && pos > limit);
  });
  $grid.removeClass("is-expanded");
  $(".byb-grid__more").toggle($(".byb-card.byb-more").length > 0);
}

function bybScrollTo(target) {
  var $t = $(target);
  if (!$t.length) return;
  var headerH = $(".ts-header").outerHeight() || 0;
  window.scrollTo({ top: $t.offset().top - headerH - 16, behavior: "smooth" });
}

function bybSetMode(mode) {
  $(".byb-tab")
    .removeClass("is-active")
    .filter('[data-byb-mode="' + mode + '"]')
    .addClass("is-active");
  bybSheet(false);
  bybScrollTo(mode === "sets" ? ".byb-sets" : ".byb-builder");
}

$(document).ready(function () {
  if (!$(".byb-builder").length) return;
  bybTiers = $(".byb-builder").data("tiers") || [];
  bybRender();
  bybShowCards("all");

  $(document).on("click", ".byb-card__swatch", function () {
    var $s = $(this);
    var $card = $s.closest(".byb-card");
    var price = Number($s.data("price"));
    var compare = Number($s.data("compare"));

    $card.find(".byb-card__swatch").removeClass("is-active");
    $s.addClass("is-active");
    $card.find(".byb-card__img").attr("src", $s.data("img"));
    $card.find(".byb-card__shade-name").text($s.data("shade"));
    $card.find(".byb-card__price-now").text(bybMoney(price).replace(".00", ""));
    $card
      .find(".byb-card__price-was")
      .text(bybMoney(compare).replace(".00", ""))
      .prop("hidden", compare <= price);
    $card
      .find(".byb-save")
      .text("SAVE " + bybMoney(compare - price).replace(".00", ""))
      .prop("hidden", compare <= price);
    $card
      .find(".byb-card__add")
      .prop("disabled", $s.hasClass("is-oos"))
      .text(
        $(".byb-builder").data(
          $s.hasClass("is-oos") ? "sold-out-label" : "add-label",
        ),
      );
    bybCardStates();
  });

  $(document).on("click", ".byb-card__add", function () {
    var $card = $(this).closest(".byb-card");
    var $s = $card.find(".byb-card__swatch.is-active");
    if (!$s.length || $s.hasClass("is-oos")) return;
    var variants = [];

    if ($s.data("shade")) {
      $card.find(".byb-card__swatch").each(function () {
        variants.push({
          id: Number($(this).data("id")),
          price: Number($(this).data("price")),
          shade: $(this).data("shade"),
          swatch: $(this).data("swatch"),
          available: !$(this).hasClass("is-oos"),
        });
      });
    }
    bybSet.push({
      id: Number($s.data("id")),
      price: Number($s.data("price")),
      title: $s.data("title"),
      img: $s.data("img"),
      variants: variants,
    });
    bybRender();
  });

  $(document).on("click", ".byb-dd__btn", function () {
    var $dd = $(this).closest(".byb-dd");
    var open = !$dd.hasClass("is-open");
    bybCloseMenus();
    $dd.toggleClass("is-open", open);
    if ($dd.hasClass("is-open")) bybPlaceMenu($dd);
  });

  $(document).on("click", ".byb-dd__opt", function () {
    var item = bybSet[Number($(this).data("index"))];
    item.id = Number($(this).data("id"));
    item.price = bybVariant(item).price;
    bybCloseMenus();
    bybRender();
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".byb-dd, .byb-dd-float").length) bybCloseMenus();
  });

  $(document).on("click", ".byb-item__remove", function () {
    bybSet.splice(Number($(this).data("index")), 1);
    bybRender();
  });

  $(document).on("click", ".byb-filter:not(.byb-filter--set)", function () {
    $(".byb-filter").removeClass("is-active");
    $(".byb-filter--set").removeClass("is-visible");
    $(this).addClass("is-active");
    bybShowCards($(this).data("category"));
  });

  $(document).on("click", ".byb-grid__more", function () {
    $(".byb-grid").addClass("is-expanded");
    $(this).hide();
  });

  $(document).on("click", "[data-byb-scroll]", function () {
    bybSheet(false);
    bybScrollTo($(this).data("byb-scroll"));
  });

  $(window).on("resize", bybBarSpace);
  $(".byb-side__body").on("scroll", bybCloseMenus);

  $(document).on("click", "[data-byb-mode]", function () {
    bybSetMode($(this).data("byb-mode"));
  });

  $(document).on("click", ".byb-setcard__btn", function () {
    var ids = $.map(String($(this).data("products")).split(","), Number);
    $(".byb-filter").removeClass("is-active");
    $(".byb-filter--set")
      .text($(this).data("title"))
      .addClass("is-visible is-active");
    bybShowCards(null, ids);
    bybSetMode("build");
  });

  $(document).on("click", ".byb-side__view", function () {
    bybSheet(true);
  });

  $(document).on("click", ".byb-side__hide, .byb-side-overlay", function () {
    bybSheet(false);
  });

  $(document).on(
    "touchstart",
    ".byb-bar, .byb-side__handle, .byb-side__head",
    bybDragStart,
  );
  $(document).on("touchmove", bybDragMove);
  $(document).on("touchend touchcancel", bybDragEnd);

  $(document).on("click", ".byb-checkout", function () {
    if (!bybSet.length) return;
    var $btn = $(this).prop("disabled", true);
    var tier = bybTier(bybSet.length);
    var qty = {};
    var items = [];

    $.each(bybSet, function (i, item) {
      qty[item.id] = (qty[item.id] || 0) + 1;
    });
    $.each(qty, function (id, q) {
      var line = { id: Number(id), quantity: q };
      if (tier) line.properties = { _OFFER: tier.pct + "%" };
      items.push(line);
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw res;
        window.location.href = "/checkout";
      })
      .catch(function () {
        $btn.prop("disabled", false);
      });
  });

  $(document).on("click", ".byb-faq__q", function () {
    $(this).closest(".byb-faq__row").toggleClass("is-open");
  });
});
